export const SCREEN_INDEX = 'index'
export const SCREEN_AUTH = 'auth'
export const SCREEN_ACCESSORIES = 'accessories'
export const SCREEN_TRADE_IN = 'trade_in'
export const SCREEN_SUCCESS = 'success'
export const SCREEN_ERROR = 'error'
export const SCREEN_CREDIT = 'credit'
export const SCREEN_LEASING = 'leasing'
export const SCREEN_ONLINE_PAYMENT = 'online_payment'
export const SCREEN_ONLINE_PAYMENT_START = 'online_payment_start'
export const SCREEN_ONLINE_PAYMENT_FAILED = 'online_payment_failed'
export const SCREEN_PROMO_PROGRAM = 'promo_program'

export const EVENT_TYPE_WIDGET_CLOSED = 'widget_closed'
export const EVENT_TYPE_WIDGET_OPEN = 'widget_open'
export const EVENT_TYPE_WIDGET_OPEN_TIME = 'widget_open_time'
export const EVENT_TYPE_WIDGET_TRADE_IN_OPEN = 'widget_trade_in_open'
export const EVENT_TYPE_WIDGET_CREDIT_CALC_OPEN = 'widget_credit_calc_open'
export const EVENT_TYPE_WIDGET_BENEFIT_SELECTED = 'widget_benefit_selected'
export const EVENT_TYPE_WIDGET_BENEFIT_UNSELECTED = 'widget_benefit_unselected'
export const EVENT_TYPE_WIDGET_GO_TO_ONLINE_PAYMENT = 'widget_online_payment_open'
export const EVENT_TYPE_WIDGET_GO_TO_SMART_CONTRACT = 'widget_smart_contract_open'
export const EVENT_TYPE_WIDGET_LEASING_CALC_OPEN = 'widget_leasing_calc_open'
export const EVENT_TYPE_AVN_FORM_REPLACED = 'widget_avn_form_replaced'

export const EVENT_TYPE_GO_TO_PROMO_PROGRAM_SCREEN = 'go_to_promo_program_screen'
export const EVENT_TYPE_GO_TO_CREDIT_SCREEN_FROM_PROMO_PROGRAM_SCREEN = 'go_to_credit_screen_from_promo_program_screen'
export const EVENT_TYPE_GO_TO_LINK_FROM_PROMO_PROGRAM_SCREEN = 'go_to_link_from_promo_program_screen'

export const CREDIT_PARTNER = {
  E_CREDIT: 'e_credit',
}

export const LEASING_SETTINGS_BEHAVIOR = {
  DISABLED: 'disabled',
  ENABLED: 'enabled',
  ENABLED_WITHOUT_CALCULATIONS: 'enabled_without_calculations',
}

export const CREDIT_SETTINGS_BEHAVIOR = {
  DISABLED: 'disabled',
  ENABLED: 'enabled',
  ENABLED_WITHOUT_CALCULATIONS: 'enabled_without_calculations',
}

export const FINANCE_USER_BEHAVIOUR = {
  NONE: 'none',
  CASH: 'cash_purchase',
  CREDIT_IN_PROGRESS: 'credit_in_progress',
  CREDIT_APPLIED: 'credit_applied',
  LEASING_IN_PROGRESS: 'leasing_in_progress',
  LEASING_APPLIED: 'leasing_applied',
}

export const CREDIT_STANDALONE_SCREEN = {
  INITIAL: 'initial',
  CARS_NOT_FOUND: 'cars_not_found',
  CREDIT_CONDITIONS: 'credit_conditions',
  PERSONAL_DATA: 'personal_data',
  CREDIT_PROGRAMS: 'credit_programs',
}

export const TRADE_IN_DATA_FILLED = {
  ALL_VALUES_FILLED: 'all',
  SOME_VALUES_FILLED: 'some',
  NO_VALUES_FILLED: 'none',
}

export const TRADE_IN_SETTINGS_BEHAVIOR = {
  DISABLED: 'disabled',
  ENABLED: 'enabled',
  ENABLED_WITHOUT_CALCULATIONS: 'enabled_without_calculations',
}

export const TRADE_IN_STANDALONE_SCREEN = {
  RATE: 'rate',
  PERSONAL_DATA_FORM: 'personal_data_form',
  SAVE: 'save',
}

/*
none - если никаких действий с ТИ не было, при localstorage - если вообще нет данных или ТИ заблокирован в виджете
started - данные заполнены частично, при localstorage - данные заполнены частично
applied - данные заполнены полностью и ТИ выбран, при localstorage - данные заполнены полностью и ТИ выбран
not_required - когда ТИ не нужен, при localstorage - когда ТИ не нужен
 */

export const TRADE_IN_USER_BEHAVIOUR = {
  NONE: 'none',
  STARTED: 'started',
  APPLIED: 'applied',
  NOT_REQUIRED: 'not_required',
}

export const TRADE_IN_RATE_STATUS = {
  INITIAL: 'initial',
  SUCCESS_WITH_ZERO_PRICE: 'success_with_zero_price',
  SUCCESS_WITH_PRICE: 'success',
  FAILED: 'failed',
}

export const CREDIT_STATUS_NONE = 'none'
export const CREDIT_STATUS_SUCCESS = 'success'
export const CREDIT_STATUS_FAILED = 'failed'
export const CREDIT_STATUS_RECEIVED = 'received'
export const CREDIT_STATUS_NO_DATA = 'no_data'

export const LEASING_RATE_STATUS = {
  INITIAL: 'initial',
  QUERY_IN_PROCESS: 'query_in_process',
  PROGRAMS_RECEIVED: 'programs_received',
  NO_PROGRAMS_FOUND: 'no_programs_found',
  ERROR: 'error',
}

export const TRADE_IN_STEP_WEIGHTS = {
  brand: 100,
  model: 200,
  generation: 300,
  body: 400,
  modification: 500,
  year: 600,
  color: 700,
  owner: 800,
  engine: 820,
  gearbox: 840,
  interiorColor: 860,
  interiorType: 880,
  city: 900,
  mileage: 1000,
}

export const TRADE_IN_STEP_WEIGHTS_BY_IDENTITY = {
  identity: 100,
  city: 200,
  mileage: 300,
}

export const TRADE_IN_COLORS = [
  {
    id: 'FAFBFB',
    name: 'white',
  },
  {
    id: 'CACECB',
    name: 'silver',
  },
  {
    id: 'C49648',
    name: 'beige',
  },
  {
    id: 'FFD600',
    name: 'yellow',
  },
  {
    id: 'DEA522',
    name: 'golden',
  },
  {
    id: 'FF8649',
    name: 'orange',
  },
  {
    id: 'FFC0CB',
    name: 'pink',
  },
  {
    id: 'EE1D19',
    name: 'red',
  },
  {
    id: '660099',
    name: 'purple',
  },
  {
    id: '200204',
    name: 'brown',
  },
  {
    id: '22A0F8',
    name: 'lightBlue',
  },
  {
    id: '0000CC',
    name: 'blue',
  },
  {
    id: '4A2197',
    name: 'violet',
  },
  {
    id: '007F00',
    name: 'green',
  },
  {
    id: '97948F',
    name: 'gray',
  },
  {
    id: '040001',
    name: 'black',
  },
]

export const TRADE_IN_OWNERS = [
  {
    id: '1',
    name: 'first',
  },
  {
    id: '2',
    name: 'second',
  },
  {
    id: '3',
    name: 'thirdAndMore',
  },
]

export const ACTION_TYPES = {
  ONLINE_APPROVAL: 'onlineApproval',
  CREATE_SMART_CONTRACT: 'createSmartContract',
  SET_PERSONAL_DATA: 'setPersonalData',
  SET_CREDIT_PROGRAM: 'setCreditProgram',
  RATE_TRADE_IN: 'rateTradeIn',
  ENABLE_BENEFIT: 'enableBenefit',
}

export const FORM_TYPES = {
  OLD_TYPE: 'inIndexScreen',
  NEW_TYPE: 'inAuthScreen',
}

export const TI_PARTNER = {
  AUTO_RU: 'auto_ru',
  MOBILE_DE: 'mobile_de',
  MAX_POSTER: 'max_poster',
  ONE_PLATFORM: 'one_platform',
}

export const CAR_STATUSES = {
  wait: {
    list_text: 'Забронирован',
    detail_text: {
      auto: 'Автомобиль забронирован',
      moto: 'Мотоцикл забронирован',
      other: 'ТС забронировано',
    },
  },
  reserved: {
    list_text: 'Забронирован',
    detail_text: {
      auto: 'Автомобиль забронирован',
      moto: 'Мотоцикл забронирован',
      other: 'ТС забронировано',
    },
  },
  sold: {
    list_text: 'Продан',
    detail_text: {
      auto: 'Автомобиль продан',
      moto: 'Мотоцикл продан',
      other: 'ТС продано',
    },
  },
  available: {
    list_text: 'Расчет выгод',
    detail_text: 'Забронировать онлайн',
  },
}

export const FORM_TYPE_BASE = 'form_type_base'
export const FORM_TYPE_ONLINE_PAYMENT = 'form_type_online_payment'

export const PLATFORM_ONE_PLATFORM = 'one_platform'

export const TRADE_IN_STORAGE_KEY = '@kodix/tradeIn'
export const TRADE_IN_OP_UPDATED_EVENT = '@kodix/tradeInUpdated'

export const SMART_CONTRACT_TRADE_IN_UPDATED_EVENT = 'smartContract_tradeInUpdated'

export const MODEL_DATA_RAW_BRAND = '00'
export const MODEL_DATA_RAW_MODEL = '01'
export const MODEL_DATA_RAW_MODEL_YEAR = '02'
export const MODEL_DATA_RAW_ENGINE_POWER_HORSE_POWER = '03'
export const MODEL_DATA_RAW_GENERATION = '04'
export const MODEL_DATA_RAW_MILEAGE = '05'
export const MODEL_DATA_RAW_COMPLECTATION = '06'
export const MODEL_DATA_RAW_COLOR = '07'

export const MODEL_DATA_ONE_PLATFORM_RESTYLING_ID = '10'
export const MODEL_DATA_ONE_PLATFORM_MARKETING_COMPLECTATION_ID = '11'
export const MODEL_DATA_ONE_PLATFORM_MARKETING_COMPLECTATION_CODE = '12'
export const MODEL_DATA_ONE_PLATFORM_BRAND_ID = '13'
export const MODEL_DATA_ONE_PLATFORM_MODEL_ID = '14'
export const MODEL_DATA_ONE_PLATFORM_COMPLECTATION_ID = '15'

export const COUNTRY_CODES = {
  belarus: {
    id: 1,
    abbr: 'By',
    abbr3: 'BLR',
    name: 'Belarus (Беларусь)',
    code: '+375',
    mask: '+375 (##) ###-##-##',
    regex: /(\+375)\s\(\d{2}\)\s(\d|-){9}$/,
    icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cmVjdCB4PSIwLjU1NiIgeT0iODUuNTIzIiBzdHlsZT0iZmlsbDojNkRBNTQ0OyIgd2lkdGg9IjUxMS40NDQiIGhlaWdodD0iMzQwLjk1NSIvPgo8cG9seWxpbmUgc3R5bGU9ImZpbGw6I0EyMDAxRDsiIHBvaW50cz0iMCwzMTUuMjk4IDUxMS40NDQsMzE1LjI5OCA1MTEuNDQ0LDg1LjUyIDUxMS40NDQsODUuNTIgMCw4NS41MiAwLDg1LjUyICIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSIxMDAuMDY1LDMxNS4yOTggMTAwLjA2NSwzMDAuNDc0IDEwMC4wNjUsODUuNTIgMCw4NS41MiAwLDQyNi40ODIgNTExLjQ0NCw0MjYuNDgyICAgNTExLjQ0NCw0MjYuNDgyIDEwMC4wNjUsNDI2LjQ4MiAiLz4KPGc+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSI2OC41NjQsMjQzLjY0NyA1MC4wMzMsMjEwLjAyOCA2OC41NjQsMTc2LjkzNyA4Ny4wOTMsMjEwLjAyOCAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSIzMS41MDIsMjQzLjY0NyAxMi45NzIsMjEwLjAyOCAzMS41MDIsMTc2LjkzNyA1MC4wMzMsMjEwLjAyOCAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSI2OC41NjQsMzM1LjA2NCA1MC4wMzMsMzAxLjQ0NiA2OC41NjQsMjY4LjM1NCA4Ny4wOTMsMzAxLjQ0NiAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSIzMS41MDIsMzM1LjA2NCAxMi45NzIsMzAxLjQ0NiAzMS41MDIsMjY4LjM1NCA1MC4wMzMsMzAxLjQ0NiAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSI2OC41NjQsNDI2LjQ4MiA1MC4wMzMsMzkyLjg2MyA2OC41NjQsMzU5Ljc3MSA4Ny4wOTMsMzkyLjg2MyAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSIzMS41MDIsNDI2LjQ4MiAxMi45NzIsMzkyLjg2MyAzMS41MDIsMzU5Ljc3MSA1MC4wMzMsMzkyLjg2MyAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSI2OC41NjQsMTUyLjIzIDUwLjAzMywxMTguNjExIDY4LjU2NCw4NS41MTggODcuMDkzLDExOC42MTEgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0EyMDAxRDsiIHBvaW50cz0iMzEuNTAyLDE1Mi4yMyAxMi45NzIsMTE4LjYxMSAzMS41MDIsODUuNTE4IDUwLjAzMywxMTguNjExICAiLz4KPC9nPgo8L3N2Zz4K',
  },
  kazakhstan: {
    id: 2,
    abbr: 'Kz',
    abbr3: 'KAZ',
    name: 'Kazakhstan (Казахстан)',
    code: '+7',
    mask: '+7 (###) ###-##-##',
    regex: /(\+7)\s\(\d{3}\)\s(\d|-){9}$/,
    icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cmVjdCB5PSI4NS4zMzEiIHN0eWxlPSJmaWxsOiMzMzhBRjM7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjM0MS4zMzciLz4KPHBhdGggc3R5bGU9ImZpbGw6I0ZGREE0NDsiIGQ9Ik0zNTIsMjY1Ljc2OEgxNjBjMCwxMy4yNTUsMTEuNTQ0LDIzLjk5OSwyNC43OTksMjMuOTk5aC0wLjc5OWMwLDEzLjI1NSwxMC43NDQsMjQuMDAxLDI0LjAwMSwyNC4wMDEgIGMwLDEzLjI1NSwxMC43NDQsMjQuMDAxLDI0LjAwMSwyNC4wMDFoNDhjMTMuMjU1LDAsMjQuMDAxLTEwLjc0NCwyNC4wMDEtMjQuMDAxYzEzLjI1NSwwLDI0LjAwMS0xMC43NDQsMjQuMDAxLTI0LjAwMWgtMC43OTkgIEMzNDAuNDU0LDI4OS43NjcsMzUyLDI3OS4wMjMsMzUyLDI2NS43Njh6Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiMzMzhBRjM7IiBkPSJNMzIyLjQ2MiwyMzQuMzg0YzAsMzYuNzA1LTI5Ljc1Niw2Ni40NjItNjYuNDYyLDY2LjQ2MnMtNjYuNDYyLTI5Ljc1Ni02Ni40NjItNjYuNDYyIi8+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBwb2ludHM9IjMyMS44ODIsMjI4LjE2MyAyOTQuOTYyLDIzOS4wNjIgMzA5LjI5NywyNjEuNTAzIDI4MC4wNjUsMjU2LjY4OSAyNzYuMzYxLDI4Mi4xMDQgICAyNTYsMjYzLjQxMiAyMzUuNjM4LDI4Mi4xMDQgMjMxLjkzNSwyNTYuNjg5IDIwMi43MDMsMjYxLjUwMSAyMTcuMDM3LDIzOS4wNjEgMTkwLjExOCwyMjguMTYzIDIxNy4wMzgsMjE3LjI2NCAyMDIuNzAzLDE5NC44MjUgICAyMzEuOTM0LDE5OS42MzggMjM1LjYzOSwxNzQuMjIxIDI1NiwxOTIuOTE1IDI3Ni4zNjIsMTc0LjIyMSAyODAuMDY1LDE5OS42MzggMzA5LjI5OCwxOTQuODI1IDI5NC45NjMsMjE3LjI2NSAiLz4KPC9zdmc+Cg==',
  },
  russia: {
    id: 3,
    abbr: 'Ru',
    abbr3: 'RUS',
    name: 'Russian Federation (Российская Федерация)',
    code: '+7',
    mask: '+7 (###) ###-##-##',
    regex: /(\+7)\s\(\d{3}\)\s(\d|-){9}$/,
    icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSIwLDg1LjMzIDAsMTk5LjEwNyAwLDMxMi44ODUgMCw0MjYuNjYyIDUxMiw0MjYuNjYyIDUxMiwzMTIuODg1IDUxMiwxOTkuMTA3IDUxMiw4NS4zMyAiLz4KPHJlY3QgeT0iODUuMzMzIiBzdHlsZT0iZmlsbDojMDA1MkI0OyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIzNDEuMzM3Ii8+CjxyZWN0IHk9Ijg1LjMzMyIgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iMTEzLjc3NSIvPgo8cmVjdCB5PSIzMTIuODg0IiBzdHlsZT0iZmlsbDojRDgwMDI3OyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxMTMuNzc1Ii8+Cjwvc3ZnPgo=',
  },
  uzbekistan: {
    id: 4,
    abbr: 'Uz',
    abbr3: 'UZB',
    name: 'Uzbekistan (Ўзбекистон)',
    code: '+998',
    mask: '+998 (##) ###-##-##',
    regex: /(\+998)\s\(\d{2}\)\s(\d|-){9}$/,
    icon: 'data:image/png;base64,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',
  },
  unitedArabEmirates: {
    id: 5,
    abbr: 'Ae',
    abbr3: 'ARE',
    name: 'United Arab Emirates (الإمارات العربية المتحدة‎)',
    code: '+971',
    mask: '+971 (##) ###-####',
    regex: /(\+971)\s\(\d{2}\)\s(\d|-){8}$/,
    icon: 'data:image/png;base64,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',
  },
  japan: {
    id: 6,
    abbr: 'Jp',
    abbr3: 'JPN',
    name: 'Japan (日本)',
    code: '+81',
    mask: '+81 (##) ####-####',
    regex: /(\+81)\s\(\d{2}\)\s(\d|-){9}$/,
    icon: 'data:image/png;base64,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',
  },
  germany: {
    id: 7,
    abbr: 'De',
    abbr3: 'DEU',
    name: 'Germany (Deutschland)',
    code: '+49',
    mask: '+49 (###) ###-####',
    regex: /(\+49)\s\(\d{3}\)\s(\d|-){8,9}$/,
    icon: 'data:image/png;base64,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',
  },
  ukraine: {
    id: 8,
    abbr: 'Ua',
    abbr3: 'UKR',
    name: 'Ukraine (Україна)',
    code: '+380',
    mask: '+380 (##) ###-##-##',
    regex: /(\+380)\s\(\d{2}\)\s(\d|-){9}$/,
    icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cmVjdCB5PSI4NS4zMzciIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjM0MS4zMjYiLz4KPHJlY3QgeT0iODUuMzM3IiBzdHlsZT0iZmlsbDojMzM4QUYzOyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxNzAuNjYzIi8+Cjwvc3ZnPgo=',
  },
}

export const DEFAULT_MILEAGES = [10000, 30000, 50000, 75000, 100000, 130000]

export const FORM_SOURCE = {
  SIMPLE_FORM: 'simpleForm', // простая форма без цены, ид, модели
  CAR_ORDER: 'carOrder', // форма без модели, берет данные из бокового виджета
  BUY_MODEL: 'buyModel', // форма с моделью, берет данные из роута boot_buy_model, есть свой стор
  WIDGET: 'widget', // из виджета
  ONLINE_PAYMENT: 'onlinePayment', // из виджета
  TRADE_IN_STANDALONE: 'tradeInStandalone', // из виджета
  CREDIT_STANDALONE: 'creditStandalone', // из виджета
  LEASING_STANDALONE: 'leasingStandalone', // из виджета
  WIDGET_AUTH: 'widgetAuth', // из виджета
}

export const CAR_ORDER_FORM_PLACEMENT = {
  PAGE: 'page', // форма на странице
  POPUP: 'popup', // форма в попапе
}

// отображает состояние формы
export const FORM_STATE = {
  FORM: 'form',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
}

export const TRADE_IN_DEFAULT_CITY_PREFIX = 'NO_ID_RUN_QUERY_'
export const TRADE_IN_CITY_TYPE_BE = 'BE'
export const TRADE_IN_CITY_TYPE_CATALOG = 'CATALOG'

export const TRADE_IN_ESTIMATION_TYPE = {
  LIST: 'list', // выбор параметров из списка (старый тип)
  AUTORU_VIN_GRZ: 'autoru_vin_grz', // авто ру (вин/грз) (новый тип)
}
